import Preact from 'preact';

var FormStructure = {
  fields: {
    headerLabel: {
      validations: []
    },
    firstName: {
      validations: [
        { type: 'required', message: 'This field is required.' }
      ]
    },
    lastName: {
      validations: [
        { type: 'required', message: 'This field is required.' }
      ]
    },
    clientName: {
      validations: []
    },
    email: {
      validations: [
        { type: 'required', message: 'This field is required.' },
        { type: 'regex', pattern: '[a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?', message: 'Please provide a valid email.' }
      ]
    },
    telNumber: {
      validations: [
        { type: 'required', message: 'This field is required.' },
        { type: 'regex', pattern: '[(]{0,1}[0-9]{3}[) ]{0,2}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}', message: 'Please provide a valid phone number.' }
      ]
    },  
    theme: {
      validations: [
        { type: 'required', message: 'This field is required.' }
      ]
    },
    plannedguestcount: {
      validations: []
    },
    reference: {
      validations: [
        { type: 'required', message: 'This field is required.' }
      ]
    },
    notes: {
      validations: []
    }
  },
  layout: {
    rows: [
      {
        fields: [
          {
            type: 'label',
            size: 'Small',
            label: 'First name *',
            mapping: 'headerLabel'
          },
          {
            type: 'text',
            size: 'Large',
            mapping: 'firstName',
            customClasses: ['no-label']
          }
        ]
      },
      {
        fields: [
          {
            type: 'label',
            size: 'Small',
            label: 'Last name *',
            mapping: 'headerLabel'
          },
          {
            type: 'text',
            size: 'Large',
            mapping: 'lastName',
            customClasses: ['no-label']
          }
        ]
      },
      {
        fields: [
          {
            type: 'label',
            size: 'Small',
            label: 'Company',
            mapping: 'headerLabel'
          },
          {
            type: 'text',
            size: 'Large',
            mapping: 'clientName',
            customClasses: ['no-label']
          }
        ]
      },
      {
        fields: [
          {
            type: 'label',
            size: 'Small',
            label: 'Email address *',
            mapping: 'headerLabel'
          },
          {
            type: 'text',
            size: 'Large',
            mapping: 'email',
            customClasses: ['no-label']
          }
        ]
      },
      {
        fields: [
          {
            type: 'label',
            size: 'Small',
            label: 'Telephone *',
            mapping: 'headerLabel'
          },
          {
            type: 'text',
            size: 'Large',
            mapping: 'telNumber',
            customClasses: ['no-label']
          }
        ]
      },
      {
        fields: [
          {
            type: 'label',
            size: 'Small',
            label: 'Type of Event *',
            mapping: 'headerLabel'
          },
          {
            type: 'multiple-choice',
            size: 'Large',
            options: [
              { label: 'Banquets/Dinners/Galas', value: 'Banquets/Dinners/Galas' },
              { label: 'BBQs (workplace or offsite catering for summer events)', value: 'BBQs (workplace or offsite catering for summer events)' },
              { label: 'Conferences', value: 'Conferences' },
              { label: 'Meeting', value: 'Meeting' },
              { label: 'Picnics (Summer events hosted at Bingemans)', value: 'Picnics (Summer events hosted at Bingemans)' },
              { label: 'Special Event', value: 'Special Event' },
              { label: 'Sport Event', value: 'Sport Event' },
              { label: 'Teambuilding', value: 'Teambuilding' },
              { label: 'Trade Show', value: 'Trade Show' },
              { label: 'Wedding', value: 'Wedding' },
              { label: 'Offsite Catering', value: 'Offsite Catering' },
              { label: 'Other', value: 'Other' },
            ],
            mapping: 'theme',
            customClasses: ['no-label']
          }
        ]
      },
      {
        fields: [
          {
            type: 'label',
            size: 'Small',
            label: 'Attendees expected',
            mapping: 'headerLabel'
          },
          {
            type: 'text',
            size: 'Large',
            mapping: 'plannedguestcount',
            customClasses: ['no-label']
          }
        ]
      },
      {
        fields: [
          {
            type: 'label',
            size: 'Small',
            label: 'How did you hear about us *',
            mapping: 'headerLabel'
          },
          {
            type: 'multiple-choice',
            size: 'Large',
            options: [
              { label: 'Search Engine', value: 'Search Engine' },
              { label: 'Social media', value: 'Social media' },
              { label: 'Promotion', value: 'Promotion' },
              { label: 'AI Inquiry', value: 'AI Inquiry' },
              { label: 'Word of mouth/referral', value: 'Word of mouth/referral' },
              { label: 'Website listing', value: 'Website listing' },
              { label: 'Online article', value: 'Online article' },
              { label: 'Trade show or wedding show', value: 'Trade show or wedding show' },
              { label: 'Other (please specify)', value: 'Other (please specify)' },
            ],
            mapping: 'reference',
            customClasses: ['no-label']
          }
        ]
      },
      {
        fields: [
          {
            type: 'label',
            size: 'Small',
            label: 'Comments',
            mapping: 'headerLabel'
          },
          {
            type: 'text-area',
            size: 'Large',
            mapping: 'notes',
            customClasses: ['no-label']
          },
        ]
      },
      {
        fields: [
          {
            type: 'label',
            size: 'Small',
            mapping: 'headerLabel',
            customClasses: ['no-label']
          },
          {
            type: 'submit',
            size: 'Large',
            label: 'Send'
          }
        ]
      }
    ]
  },
  info: {
    title: 'Bingemans - Conference Centre Contact Us Form',
    formId: '571',
    clientKey: 'CE09530B-9886-4292-A644-85466DC1AFF5',
    appKey: '23697F14-AA8C-4622-9F64-FC1A9FF20D0D',
    redirectUrl: 'https://bingemans.com/contact-thank-you.php',
    submissionText: '',
    apiEndpoint: '//api-cec.catereasewebtools.com/inbound-inquiries'
  }
};


export default FormStructure;
